export class LeaveGameRequest {
    static Message = 'LeaveGameRequest';

    public gameId: string;
    public socketId: string;

    constructor(gameId: string, socketId: string) {
        this.gameId = gameId;
        this.socketId = socketId;
    }
}

export class LeaveGameResponse {
    static Message = 'LeaveGameResponse';
}
